import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Error al obtener la sesión:', error);
          toast.error('Error al reestablecer la sesión');
          navigate('/login');
        } else if (session) {
          console.log('Sesión obtenida correctamente');
          navigate('/profile');
        } else {
          console.error('No se encontró sesión después del callback');
          toast.error('No se pudo reestablecer la sesión');
          navigate('/login');
        }
      } catch (error) {
        console.error('Error inesperado en el callback:', error);
        if (error instanceof Error) {
          toast.error(`Error inesperado: ${error.message}`);
        } else {
          toast.error('Error inesperado al procesar el callback');
        }
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Procesando autenticación...</h1>
        <p className="text-gray-600">Por favor, espera un momento mientras completamos tu inicio de sesión.</p>
      </div>
    </div>
  );
};

export default AuthCallback; 